module.exports = "/_next/static/resources/photo-2-a26d8aecb78a8ffa59c39aaf6961fa76.jpg";